import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ArrowExpandIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d='M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z' />
  </SvgIcon>
);

export default ArrowExpandIcon;
